import { useCallback, useSyncExternalStore } from 'react';
import type { MatrixUserState } from '../stores/MatrixUserStore';
import { matrixUserStore } from '../stores/MatrixUserStore';

export function useMatrixUser(userId: string): MatrixUserState {
  const subscribe = useCallback((listener: () => void) => matrixUserStore.subscribe(userId, listener), [userId]);

  const getSnapshot = useCallback(() => matrixUserStore.getSnapshot(userId), [userId]);

  return useSyncExternalStore(subscribe, getSnapshot);
}
